import { requestHandler } from '../../../api';

export const getCachedSuperDebt = async (dispatch: any, businessId: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/debt/${businessId}/deuda12`,
    dispatch,
  });
  if (response) return response.data;
};
